import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { DEFAULT_CURRENCY } from "../lib/defaultCurrency";

const FxContext = createContext({ rates: { USD: 1 } });

export function FxProvider({ children }) {
    const [rates, setRates] = useState({ USD: 1, EUR: 0.92, GBP: 0.78, CAD: 1.36, AUD: 1.5, INR: 83, JPY: 156, SGD: 1.34, CHF: 0.88 });

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const { data } = await api.get("/fx/rates");
                if (mounted && data?.rates) setRates(data.rates);
            } catch (_e) { /* keep fallback */ }
        };
        load();
        const t = setInterval(load, 30 * 60 * 1000); // 30 min
        return () => { mounted = false; clearInterval(t); };
    }, []);

    const convert = useCallback((amount, from = DEFAULT_CURRENCY, to = DEFAULT_CURRENCY) => {
        if (!amount && amount !== 0) return 0;
        const fromUsd = (rates[from] || 1);
        const toUsd = (rates[to] || 1);
        return (amount / fromUsd) * toUsd;
    }, [rates]);

    return <FxContext.Provider value={{ rates, convert }}>{children}</FxContext.Provider>;
}

export function useFx() { return useContext(FxContext); }

const CURRENCY_SYMBOL = { USD: "$", EUR: "€", GBP: "£", CAD: "C$", AUD: "A$", INR: "₹", JPY: "¥", SGD: "S$", CHF: "CHF " };

export function currencySymbol(code = DEFAULT_CURRENCY) {
    return CURRENCY_SYMBOL[code] || `${code} `;
}

function currencyLocale(code) {
    if (code === "GBP") return "en-GB";
    if (code === "EUR") return "de-DE";
    return "en-US";
}

export function formatCurrency(amount, code = DEFAULT_CURRENCY, { decimals = 0 } = {}) {
    const symbol = currencySymbol(code);
    const formatted = (amount || 0).toLocaleString(currencyLocale(code), {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
    return `${symbol}${formatted}`;
}

export const SUPPORTED_CURRENCIES = ["GBP", "USD", "EUR", "CAD", "AUD", "INR", "JPY", "SGD", "CHF"];
